import React, { useState, useRef, useEffect } from "react";
import "./Chatbot.css";

const Chatbot = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [messages, setMessages] = useState([]);

  // 🔑 Ref for auto-scroll sentinel
  const messagesEndRef = useRef(null);
  

  // 🔑 Auto-scroll effect
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);
  useEffect(() => {
  const handleCloseChat = () => {
    setIsChatOpen(false);
  };

  window.addEventListener("closeChat", handleCloseChat);

  return () => {
    window.removeEventListener("closeChat", handleCloseChat);
  };
}, []);

 const toggleChat = () => {
  const opening = !isChatOpen;

  if (opening) {
    // Close the video widget
    window.dispatchEvent(new Event("closeVideo"));

    // Add welcome message only the first time
    if (messages.length === 0) {
      setMessages([
        {
          text: "👋 Hi! I’m your virtual assistant for the ACGCET website. I can help you navigate the site and find the information you’re looking for.",
          sender: "bot",
        },
      ]);
    }
  }

  setIsChatOpen(opening);
};

  const closeChat = () => {
    setIsChatOpen(false);
  };

  const handleSendMessage = () => {
    const message = userInput.trim();
    if (message === "") return;

    // 👤 Add user message
    const newMessages = [...messages, { text: message, sender: "user" }];
    setMessages(newMessages);
    setUserInput("");

    // ✅ Show typing animation
    setMessages((prev) => [...prev, { sender: "bot", typing: true }]);
   fetch("/chatbot/ask", {
       // replace chatbot wiht 127.0.0.1:8000 or localhost:8000 if testing locally
      //fetch("http://127.0.0.1:8000/ask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ query: message }),
    })
      .then((response) => response.json())
      .then((data) => {
        // ✅ Remove typing animation and push actual reply
        setMessages((prev) => [
          ...prev.filter((msg) => !msg.typing),
          { text: data.response, sender: "bot" },
        ]);
      })
      .catch((error) => {
        console.error("Error sending message:", error);

        setMessages((prev) => [
          ...prev.filter((msg) => !msg.typing),
          { text: "⚠️ Server error. Try again.", sender: "bot" },
        ]);
      });
  };

  return (
    <div>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
      />

      <div className="chat-button1" onClick={toggleChat}>
        <span className="chat-tooltip">👋 Hi! I’m the ACGCET Assistant</span>
        <i className="material-icons chat">chat</i>
      </div>

      <div className={`chat-container1 ${isChatOpen ? "opened" : "ji"}`}>
        <div className="chat-header1">
          <div id="online-status1"></div>
          <div id="toolbar-title1">ACGCET-Assistant</div>
          <span className="minimise-button1" onClick={closeChat}>
            <i className="material-icons chat-close">close</i>
          </span>
        </div>

        {/* Chat Messages */}
        <div className="chat-messages1">
          {messages.map((message, index) => {
            if (message.typing) {
              return (
                <div
                  key={index}
                  className="message-bubble1 bot-message typing-indicator"
                >
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </div>
              );
            }

            return (
              <p
                key={index}
                dangerouslySetInnerHTML={{ __html: message.text }}
                className={`message-bubble1 ${message.sender}-message`}
              ></p>
            );
          })}
          {/* ✅ Sentinel element for auto-scroll */}
          <div ref={messagesEndRef} />
        </div>

        {/* Input Box */}
        <div className="chat-bottom">
          <div className="chat-input1">
            <input
              type="text"
              id="chat-input1"
              placeholder="Ask a question..."
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  handleSendMessage();
                }
              }}
            />
            <button
              className="material-icons"
              id="send-button1"
              onClick={handleSendMessage}
              type="button"
            >
              send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chatbot;
